import { render, staticRenderFns } from "./mainland.vue?vue&type=template&id=a5c828d2&scoped=true"
import script from "./mainland.vue?vue&type=script&lang=js"
export * from "./mainland.vue?vue&type=script&lang=js"
import style0 from "./mainland.vue?vue&type=style&index=0&id=a5c828d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c828d2",
  null
  
)

export default component.exports